import React, { useEffect, useState } from 'react';
import { fetchCultivarsByIds } from '@/lib/botanical';
import { useLang } from '@/i18n/LanguageContext';
const requests = new Map();
export default function CultivarNames({ farm }) {
  const { lang } = useLang();
  const selections = [...(farm.reference_botanical_selections || []), ...(farm.botanical_selections || [])];
  const key = JSON.stringify([...new Set(selections.map(s => s.cultivar_id).filter(Boolean))].sort());
  const [rows, setRows] = useState([]);
  useEffect(() => {
    let active = true;
    if (!requests.has(key)) requests.set(key, fetchCultivarsByIds(JSON.parse(key)).catch(() => { requests.delete(key); return []; }));
    requests.get(key).then(data => { if (active) setRows(data); });
    return () => { active = false; };
  }, [key]);
  const entries = selections.flatMap(s => s.custom_cultivar ? s.custom_cultivar.split(/[,;]/).map(n => ({name:n.trim(), custom:true})) : s.cultivar_id ? [{name:rows.find(r => r.id === s.cultivar_id)?.name, custom:false}] : []);
  const unique = [...new Map(entries.filter(e => e.name).map(e => [e.name.toLowerCase(),e])).values()];
  if (!unique.length) return null;
  return <p className="text-sm mt-3"><strong>{lang === 'it' ? 'Varietà indicate' : 'Listed cultivars'}: </strong>{unique.length} <span className="text-[#6E6258]">— {lang === 'it' ? 'dettagli nella scheda' : 'details in the profile'}</span></p>;
}
